import { useCallback, useEffect } from 'react';

import Button from 'src/components/buttons/Button';
import { CommerceBannerProps } from 'src/types/commerce';
import {
  buttonEvent,
  exploreLooks
} from 'src/utils/analytics/mixpanel/mixpanelEventsHelper';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  MIXPANEL_EXPLORE_NOW,
  MIXPANEL_WISHLIST
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import {
  AnimatedBanner,
  ButtonContainer,
  CommerceBannerWrapper,
  explore,
  GradientContainer,
  SubTitle,
  Title,
  titleContainer,
  wishlist
} from './styles';

const CommerceBanner: React.FC<CommerceBannerProps> = ({
  showWishlist,
  handleCommerceLayout
}) => {
  const {
    commerceWishlistedProductsLength: wishlistedProductsLength,
    translations
  } = useAppStore();
  const {
    plex: {
      ContextualCommerce_Explore = '',
      ContextualCommerce_BannerText = '',
      ContextualCommerce_BannerCTA = '',
      ContextualCommerce_Wishlist = '',
      ContextualCommerce_WishlistBannerCTA = '',
      ContextualCommerce_BannerDescriptionMov = ''
    } = {}
  } = translations || {};
  const titleText = wishlistedProductsLength
    ? ContextualCommerce_WishlistBannerCTA
    : ContextualCommerce_BannerCTA;
  const subtitleText = wishlistedProductsLength
    ? ContextualCommerce_BannerDescriptionMov
    : ContextualCommerce_BannerText;
  const wishlistText = wishlistedProductsLength
    ? ContextualCommerce_Wishlist + ' (' + wishlistedProductsLength + ')'
    : ContextualCommerce_Wishlist;

  useEffect(() => {
    exploreLooks();
  }, []);

  const wishlistHandler = useCallback(() => {
    buttonEvent(`${MIXPANEL_WISHLIST} (${wishlistedProductsLength})`);
    if (showWishlist) {
      showWishlist();
    }
  }, [wishlistedProductsLength]);

  const exploreLooksHandler = useCallback(() => {
    buttonEvent(MIXPANEL_EXPLORE_NOW);
    if (handleCommerceLayout) {
      handleCommerceLayout();
    }
  }, []);

  return (
    <>
      <AnimatedBanner>
        <CommerceBannerWrapper>
          <GradientContainer>
            <div css={titleContainer(wishlistedProductsLength)}>
              <Title>{titleText}</Title>
              <SubTitle>{subtitleText}</SubTitle>
            </div>
            <ButtonContainer>
              <Button
                customStyles={wishlist}
                title={ContextualCommerce_Wishlist}
                callback={wishlistHandler}>
                {wishlistText}
              </Button>
              <Button
                customStyles={explore}
                title={ContextualCommerce_Explore}
                callback={exploreLooksHandler}>
                {ContextualCommerce_Explore}
              </Button>
            </ButtonContainer>
          </GradientContainer>
        </CommerceBannerWrapper>
      </AnimatedBanner>
    </>
  );
};

export default CommerceBanner;
